import classNames from 'classnames';
import s from './PageTitle.module.scss';

type Props = {
  title: string;
  element?: 'h2' | 'h1' | 'legend';
  classes?: string;
  isCentered?: boolean;
  size?: 'responsive' | 'small' | 'medium' | 'large';
};

const PageTitle = ({
  title,
  element = 'h2',
  classes,
  isCentered,
  size = 'responsive',
}: Props) => {
  const blockClass = classNames(s.host, classes, {
    [s.isCentered]: isCentered,
    [s.responsive]: size === 'responsive',
    [s.small]: size === 'small',
    [s.medium]: size === 'medium',
    [s.large]: size === 'large',
  });

  if (element === 'h2') {
    return <h2 className={blockClass}>{title}</h2>;
  }
  if (element === 'h1') {
    return <h1 className={blockClass}>{title}</h1>;
  }
  if (element === 'legend') {
    return <legend className={blockClass}>{title}</legend>;
  }

  return null;
};

export default PageTitle;
